import React, { useState, useCallback, useMemo, MouseEvent } from 'react';
import {
  CONFIGURATION_TYPES,
  defaultCarImageUrl,
  OFFER_STATUSES,
  Transmission,
  VEHICLE_OFFER_ASSIGNMENT,
  VEHICLE_OFFER_EVENT_DESCRIPTIONS
} from '../../constants';
import toMoney from '../../utils/toMoney';
import More, { MoreMenuItem } from '../more';
import Spinner from 'components/spinner';
import AllInclusive from './all-inclusive';
import Price from './price';
import classes from './product.module.scss';
import './product.scss';
import { CircleQuestionMarkIcon } from '../icons/circle-question-mark';
import DownArrow from '../icons/down_arrow';
import { getDateString } from '../../utils/convert-UTC-date-to-local-date';
import { encodeBase64 } from '../../utils/decode-encode-base64';
import { Flex, Text } from '../../common/common-components.styled';
import { formFields } from '../monatsrechnungen/formFields/formFields';
import Form from 'components/form/form-redux';
import { createNewTaskHandler } from 'utils/create-new-task-handler';
import Snackbar from '../snackbar';
import { useLocation, useHistory } from 'react-router-dom';
import { useTypedSelector } from 'hooks/use-typed-selector';
import { useOverlay, useQuery } from 'hooks';
import { useDispatch } from 'react-redux';
import { addToComparison, deleteFromComparison, toggleComparisonPanel } from '../../actions/comparison_action';
import { setForm, toggleModal } from '../../actions/app_action';
import { MODALS, MODAL_NAMES } from '../../constants';
import {
  DateInfoProps,
  TriangleProps,
  InfoItemProps,
  ProductInfoProps,
  ProductProps,
  ItemPropsForList
} from './product-view.props';
import { useTheme } from 'styled-components';
import { CarWithEuroIcon } from '../icons/offer-statuses/car-with-euro-icon';
import { GasStationIcon } from '../icons';
import { useVehileLogo } from 'hooks/react-query/vehile-logo';
import useLatestValue from 'hooks/use-latest-value';
import classNames from 'classnames';
import { PAGES } from 'common/enums';
import { AskQuestionIcon } from 'components/icons/ask-qustion-icon';
import ButtonWithIcon from 'components/button-with-icon';
import {
  SUBMIT_GRV_BUTTON_TEXT_DRIVER,
  SUBMIT_GRV_BUTTON_TEXT_FLEET_MANAGER
} from 'pages/details/order-widget/order-widget';
import { removeSpaces } from 'utils/remove-spaces';
import { getPriceAndFuelCost, getTileNumber } from 'components/product/utils';
import { openInNewTabHandler } from 'utils/open-page-in-new-tab';
import useOfferStatus from 'hooks/react-query/use-offer-status';
import useLatestEvents from 'hooks/use-latest-events';
import useOldestEvents from 'hooks/use-oldest-events';
import useDeactivateDialog from './hooks/use-deactivate-dialog';
import { StyledCarPolicy } from 'pages/release-external-page/release-external-page.styled';
import { CalendarIcon } from '../icons-new/calendar';
import { CustomersIcon } from '../icons-new/customers';
import { TooltipComponent } from '../tooltip-component/tooltip-component';
import { InfoHintIcon } from '../icons-new/info-hint';
import { DeactivateIcon } from '../icons-new/deactivate';
import useEventDescriptionsUtils from '../../hooks/use-event-descriptions-utils';
import { isShowInfoHint } from '../vehicle-offers-list-component/select-configuration-to-deactivate/unable-to-deactivate/unable-to-deactivate';
import ThreeStateCheckbox from '../three-state-checkbox';
import EllipsisWithTooltip from '../ellipsis-with-tooltip';
import useTargetEventColorAndIcon from './hooks/use-target-event-color-and-icon';

export const DateInfo = ({ icon, title, value }: DateInfoProps) => {
  return (
    <div className={classes.date_info}>
      <>
        {icon}
        {title && (
          <span id={removeSpaces(title) + 'Title'} className={classes.title}>
            {title}
          </span>
        )}
        <span id={removeSpaces(title) + 'Value'} className={classes.date}>
          {value}
        </span>
      </>
    </div>
  );
};

const Triangle = ({ width, height, color, rotate }: TriangleProps) => {
  return (
    <div
      style={{
        width: '0',
        height: '0',
        borderStyle: 'solid',
        borderWidth: `0 0 ${height}px ${width}px`,
        borderColor: `transparent transparent ${color} transparent`,
        transform: `rotate(${rotate}deg)`
      }}
    />
  );
};

const InfoItem = ({ children }: InfoItemProps) => {
  return (
    <div className='d-flex'>
      <Triangle width={4} height={24} color={'#102F3F'} />
      <div style={{ width: '5px', height: '24px', backgroundColor: '#102F3F' }} />
      <Triangle width={4} height={24} color={'#102F3F'} rotate={180} />
      <div className='d-flex' style={{ marginLeft: '-4px' }}>
        <Triangle width={4} height={24} color={'#009383'} />
        <div className={classes.new_uds_info_item}>{children}</div>
        <Triangle width={4} height={24} color={'#009383'} rotate={180} />
      </div>
    </div>
  );
};

const ProductInfo = ({ label, value }: ProductInfoProps) => {
  const idBase = typeof label === 'string' ? removeSpaces(label) : 'ProductInfo';
  return (
    <div className={classes.new_uds_product_info}>
      <p id={idBase + 'Label'} className={classes.new_uds_label}>
        {label}
      </p>
      <p id={idBase + 'Value'} className={classes.new_uds_value}>
        {value}
      </p>
    </div>
  );
};

const CONFIRM_BUTTON_TEXT = {
  [OFFER_STATUSES.configurationCreated]: 'Leasingangebot anfragen',
  [OFFER_STATUSES.requirementApproved]: 'Leasingfahrzeug anfordern',
  [OFFER_STATUSES.vehicleConfigurationBasedOnGRVCreated]: 'Leasingfahrzeug anfordern',
  [OFFER_STATUSES.purchaseTriggered]: 'Leasinganforderung freigeben',
  [OFFER_STATUSES.globalReferenceVehicleGeneratedViaAPI]: 'Konfigurieren'
};

const spinnerStyle = {
  width: '50px',
  height: '50px',
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%,-50%)'
};

export const detailsPagesMapping = {
  [PAGES.CONFIGURATIONS]: PAGES.CONFIGURATION_DETAILS,
  [PAGES.EMPLOYEE_CONFIGURATIONS]: PAGES.EMPLOYEE_CONFIGURATION_DETAILS
};

const Product = ({ reloadList, item, setUseQueryKey }: ProductProps) => {
  const query = useQuery();
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const theme = useTheme();
  const user = useTypedSelector(state => state.app.user);
  const comparisonCars = useTypedSelector(state => state.comparison.cars);
  const forms = useTypedSelector(state => state.app.forms);
  const formsLatest = useLatestValue(forms);
  const [showOverlay, hideOverlay] = useOverlay();

  const isEmployeeConfigurationsPage = location.pathname.includes(PAGES.EMPLOYEE_CONFIGURATIONS);
  const isNewEmployeeConfigurationsPage = location.pathname.includes(PAGES.NEW_REFERENCE_CONFIGURATIONS);
  const isDriverConfigurationPage =
    location.pathname.includes(PAGES.CONFIGURATIONS) && !location.pathname.includes(PAGES.NEW_CONFIGURATIONS);

  const isCarCompared = !!comparisonCars.find(
    (car: ItemPropsForList) => car.uds_fahrzeugangeboteid === item.uds_fahrzeugangeboteid
  );
  const isPoolcar = item.uds_zuordnung?.value === VEHICLE_OFFER_ASSIGNMENT.poolCar.value;
  const isFahrzeugeDerCarPolicyPage =
    location.pathname.includes(PAGES.REFERENCE_VEHICLES) &&
    !location.pathname.includes(PAGES.NEW_REFERENCE_CONFIGURATIONS);
  const isNewDriverConfigurationPage = location.pathname.includes(PAGES.NEW_CONFIGURATIONS);

  const { globalReferenceVehicleGeneratedViaAPIEvent } = useLatestEvents(item.events);
  const {
    configurationCreatedEvent,
    vehicleConfigurationBasedOnGRVCreatedEvent,
    offerPublishedForUsersEvent,
    vehicleBasedOnBulkOrderCreatedEvent
  } = useOldestEvents(item.events);
  const { openDeactivateDialog } = useDeactivateDialog({ configuration: item, refreshList: () => reloadList(true) });

  const queryData = query.data || null;

  const [isShowAllesInklusive, setIsShowAllesInklusive] = useState(false);
  const configurationUploaded =
    configurationCreatedEvent?.uds_eventdescription?.id === VEHICLE_OFFER_EVENT_DESCRIPTIONS.configurationUploaded.id;
  const isBasedOnGlobalReferenceVehicle = !!vehicleConfigurationBasedOnGRVCreatedEvent;
  const isGlobalReferenceVehicle = !!globalReferenceVehicleGeneratedViaAPIEvent;
  const isBulkOrderVehicle =
    !!offerPublishedForUsersEvent && item.uds_configurationtypecode?.value === CONFIGURATION_TYPES.bulkOrder.value;
  const isBasedOnBulkOrderVehicle = !!vehicleBasedOnBulkOrderCreatedEvent;

  const { data: img, isFetched: imgIsFetched } = useVehileLogo(item.sharepointLocation, defaultCarImageUrl);

  const { offerStatus: vehicleOfferStatus } = useOfferStatus(
    item.events,
    isEmployeeConfigurationsPage || isNewEmployeeConfigurationsPage,
    isNewDriverConfigurationPage
  );

  const isOrderCompleted = [OFFER_STATUSES.orderCompleted].includes(vehicleOfferStatus);

  const { fuelCost, priceWithoutFuelCost } = getPriceAndFuelCost(isGlobalReferenceVehicle, isOrderCompleted, item);

  const [snackbar, setSnackbar] = useState({
    message: '',
    type: ''
  });

  const { buttonText, isShowIcon } = useMemo(() => {
    if (
      [
        OFFER_STATUSES.configurationCreated,
        OFFER_STATUSES.requirementApproved,
        OFFER_STATUSES.purchaseTriggered,
        OFFER_STATUSES.globalReferenceVehicleGeneratedViaAPI,
        OFFER_STATUSES.vehicleConfigurationBasedOnGRVCreated
      ].includes(vehicleOfferStatus) &&
      !isFahrzeugeDerCarPolicyPage &&
      !isBasedOnGlobalReferenceVehicle &&
      !isBulkOrderVehicle
    ) {
      return { buttonText: CONFIRM_BUTTON_TEXT[vehicleOfferStatus], isShowIcon: true };
    }

    if (
      [
        OFFER_STATUSES.vehicleConfigurationBasedOnGRVCreated,
        OFFER_STATUSES.vehicleRequested,
        OFFER_STATUSES.buildAbilityConfirmed
      ].includes(vehicleOfferStatus) &&
      !(
        [OFFER_STATUSES.vehicleRequested, OFFER_STATUSES.buildAbilityConfirmed].includes(vehicleOfferStatus) &&
        isDriverConfigurationPage
      ) &&
      !isFahrzeugeDerCarPolicyPage &&
      isBasedOnGlobalReferenceVehicle &&
      !isBulkOrderVehicle
    ) {
      return {
        buttonText: isEmployeeConfigurationsPage
          ? SUBMIT_GRV_BUTTON_TEXT_FLEET_MANAGER[vehicleOfferStatus]
          : SUBMIT_GRV_BUTTON_TEXT_DRIVER[vehicleOfferStatus],
        isShowIcon: true
      };
    }

    if (isBulkOrderVehicle) {
      return { buttonText: 'Fahrzeug anfordern', isShowIcon: true };
    }

    if (
      isBasedOnBulkOrderVehicle &&
      isEmployeeConfigurationsPage &&
      [OFFER_STATUSES.vehicleBasedOnBulkOrderCreated].includes(vehicleOfferStatus)
    ) {
      return { buttonText: 'Freigabe anfordern', isShowIcon: true };
    }

    return { buttonText: 'Zu den Details', isShowIcon: false };
  }, [vehicleOfferStatus]);

  const openPage = async (ctrlKeyPressed?: boolean) => {
    !ctrlKeyPressed && showOverlay();
    !ctrlKeyPressed && dispatch(toggleComparisonPanel(false));
    try {
      const id = encodeBase64(item.uds_fahrzeugangeboteid as string);

      let link = `${
        isEmployeeConfigurationsPage
          ? PAGES.EMPLOYEE_CONFIGURATION_DETAILS
          : isNewEmployeeConfigurationsPage
          ? PAGES.REFERENCE_VEHICLES_DETAILS
          : PAGES.CONFIGURATION_DETAILS
      }?id=${id}`;
      if (queryData) {
        link += `&data=${queryData}`;
      }
      ctrlKeyPressed ? openInNewTabHandler(`${window.location.origin}${link}`, 500) : history.push(link);
    } catch (error) {
      //TODO: Add error handling
      console.log('Error while retrieving data for page redirect');
    } finally {
      !ctrlKeyPressed && hideOverlay();
    }
  };

  const showAllesInklusive = useCallback(() => {
    setIsShowAllesInklusive(true);
  }, []);

  const hideAllesInklusive = useCallback(() => {
    setIsShowAllesInklusive(false);
  }, []);

  const addCarToComparison = useCallback(
    (event: any) => {
      event.stopPropagation?.();
      if (comparisonCars.length < 4) {
        dispatch(addToComparison({ ...item, image: img }));
        dispatch(toggleComparisonPanel(true));
      }
    },
    [comparisonCars, dispatch, img, item]
  );

  const deleteCarFromComparison = useCallback(
    (event: any) => {
      event.stopPropagation?.();
      dispatch(deleteFromComparison(item.uds_fahrzeugangeboteid));
    },
    [dispatch, item]
  );

  const snackbarSetup = useCallback((message: any, type: any) => {
    setSnackbar({
      message: message,
      type: type
    });
  }, []);

  const closeAlert = useCallback(() => {
    dispatch(toggleModal(MODALS.alert, null));
  }, [dispatch]);

  const openCreateNewTaskModal = useCallback(
    (e: any) => {
      e.stopPropagation();
      const alertData = {
        title: 'Neue Frage',
        children: <Form name='frage' formFields={formFields} />,
        buttons: [
          {
            type: 'cancel',
            title: 'Abbrechen',
            action: closeAlert
          },
          {
            type: 'submit',
            title: 'Speichern',
            action: () =>
              createNewTaskHandler({
                itemId: item.uds_fahrzeugangeboteid as string,
                userId: user.id,
                closeAlert: closeAlert,
                dispatchForm: form => {
                  dispatch(setForm(form));
                },
                formsLatest: formsLatest.current,
                hideOverlay: hideOverlay,
                showOverlay: showOverlay,
                snackbarSetup: snackbarSetup,
                logicalName: 'uds_fahrzeugangebote'
              })
          }
        ]
      };
      dispatch(toggleModal(MODALS.alert, MODAL_NAMES.alert, alertData));
    },
    [dispatch, formsLatest.current, hideOverlay, item, showOverlay, snackbarSetup, user, closeAlert]
  );

  const productOnClick = (e: MouseEvent) => {
    if (!isFahrzeugeDerCarPolicyPage) {
      const ctrlKeyPressed = e?.ctrlKey;
      if (ctrlKeyPressed) {
        return openPage(ctrlKeyPressed);
      }
      openPage();
      setUseQueryKey();
    }
  };

  const isNewUdsOrderedClassName =
    [OFFER_STATUSES.vehicleRequested, OFFER_STATUSES.purchaseTriggered, OFFER_STATUSES.orderApproved].includes(
      vehicleOfferStatus
    ) &&
    !(vehicleOfferStatus === OFFER_STATUSES.vehicleRequested && isEmployeeConfigurationsPage) &&
    !(vehicleOfferStatus === OFFER_STATUSES.orderApproved && isEmployeeConfigurationsPage) &&
    !isNewEmployeeConfigurationsPage &&
    !isFahrzeugeDerCarPolicyPage;

  const containerClassName = classNames(classes.new_uds_product, {
    [classes.new_uds_ordered]: isNewUdsOrderedClassName,
    [classes.new_uds_canceled]: !isNewUdsOrderedClassName && vehicleOfferStatus === OFFER_STATUSES.approvalRejected,
    table: !isFahrzeugeDerCarPolicyPage
  });

  const { getEventDescriptionForVehicleStatus, getAppStatusTextById } = useEventDescriptionsUtils();

  const eventDescription = getEventDescriptionForVehicleStatus(item.events);
  const { appStatusText: eventDescriptionAppText, isDone } = getAppStatusTextById(
    eventDescription?.uds_fahrzeugbestellungeneventdescriptionid || ''
  );

  const targetEvent = useMemo(
    () =>
      item.events.find(
        event => event.uds_eventdescription?.id === eventDescription?.uds_fahrzeugbestellungeneventdescriptionid
      ),
    [item.events, eventDescription]
  );
  const { targetEventColor, targetEventIcon, space } = useTargetEventColorAndIcon(
    isDone,
    eventDescription?.uds_app_status_filter_value?.value
  );

  return (
    <section
      id={item.uds_name + 'Tile'}
      style={{ cursor: isFahrzeugeDerCarPolicyPage ? 'default' : 'pointer' }}
      onClick={productOnClick}
      className={containerClassName}
    >
      {(isNewDriverConfigurationPage || isNewEmployeeConfigurationsPage) && item.isEco ? (
        <img className={classes.eco_badge} src='/assets/images/eco-badge.svg' alt='eco-badge' />
      ) : null}

      {(isEmployeeConfigurationsPage || isDriverConfigurationPage) &&
      !isShowInfoHint(item.uds_remove_request_date?.value) ? (
        <div className={'hidden-md hidden-lg'}>
          <More>
            <MoreMenuItem
              label='Konfiguration archivieren'
              minWidth={'240px'}
              onClick={openDeactivateDialog}
              img={<DeactivateIcon />}
            />
          </More>
        </div>
      ) : null}

      <div className={classes.new_uds_content}>
        <div className={classes.new_uds_content_container}>
          <div className={classes.new_uds_image_description}>
            <div className={classes.new_uds_image_container}>
              {imgIsFetched ? null : <Spinner style={spinnerStyle} />}
              <img src={img} alt={`Foto - ${item.uds_title}`} />
              {img !== defaultCarImageUrl && (
                <Text top='5' size='12' color='grey600'>
                  *Gelieferte Fahrzeuge können von der Abbildung abweichen
                </Text>
              )}
              {/*<ConsumptionSmallText item={item} styles={{ fontSize: '9px', marginTop: '0px' }} showFANumber={false} />*/}
              {user.isTestUser && (isGlobalReferenceVehicle || isBasedOnGlobalReferenceVehicle) && (
                <Text top='10' color='grey400' size='12'>
                  {getTileNumber(
                    vehicleOfferStatus,
                    isNewDriverConfigurationPage,
                    isDriverConfigurationPage,
                    isNewEmployeeConfigurationsPage,
                    isEmployeeConfigurationsPage
                  )}
                </Text>
              )}
            </div>

            <div className={classes.new_uds_description}>
              <Flex direction='column'>
                <Flex direction='column' bottom='30'>
                  <EllipsisWithTooltip tooltip={item.uds_title as string}>
                    <h4 id={item.uds_name + 'VehicleTitle'}>{item.uds_title as string}</h4>
                  </EllipsisWithTooltip>
                  {eventDescriptionAppText && targetEvent && (
                    <Flex align='center'>
                      {targetEventIcon}
                      <EllipsisWithTooltip
                        tooltip={`${eventDescriptionAppText}: ${getDateString(targetEvent.createdon.value)}`}
                      >
                        <Text left={space} color={targetEventColor}>
                          {eventDescriptionAppText}: {getDateString(targetEvent.createdon.value)}
                        </Text>
                      </EllipsisWithTooltip>
                    </Flex>
                  )}
                </Flex>

                <ProductInfo
                  label={
                    isNewDriverConfigurationPage || isNewEmployeeConfigurationsPage || isFahrzeugeDerCarPolicyPage
                      ? 'Referenzfahrzeug:'
                      : 'Konfiguration:'
                  }
                  value={item.uds_name || '-'}
                />
                <ProductInfo
                  label='Bruttolistenpreis:'
                  value={item.uds_listenpreis?.value ? toMoney(item.uds_listenpreis.value) : '-'}
                />
                {configurationUploaded ? (
                  <Flex top='30'>
                    <Flex top='3'>
                      <InfoHintIcon width={18} height={18} color={theme.colors.grey900} cursor='default' />
                    </Flex>
                    <Text left='10' color='grey900'>
                      Da diese Konfiguration nicht über die App erstellt wurde, sind keine Fahrzeuginformationen
                      verfügbar.
                    </Text>
                  </Flex>
                ) : (
                  <>
                    <ProductInfo
                      label={
                        <Flex align='center'>
                          Kraftstoff
                          <TooltipComponent
                            title={
                              <div>
                                <Text>Kraftstoffverbr.*: {item.uds_uds_fuelconsumption_combined || '-'} (komb.),</Text>
                                <Text>CO₂-Emissionen*: {item.uds_co2_emission_combined || '-'} g/km (komb.)</Text>
                              </div>
                            }
                          >
                            <Flex left='3'>
                              <InfoHintIcon width='14' height='14' />
                            </Flex>
                          </TooltipComponent>
                          :
                        </Flex>
                      }
                      value={item.uds_enginetypecode?.label || '-'}
                    />
                    <ProductInfo label={'Leistung kW:'} value={String(item.uds_leistungkw || '-')} />
                    <ProductInfo
                      label={'Getriebe:'}
                      value={Transmission[item.uds_getriebe?.value as unknown as keyof typeof Transmission] || '-'}
                    />
                  </>
                )}
              </Flex>
            </div>
          </div>

          {!!item.carPolicyList?.length && (
            <Flex top='25' wrap='wrap' align='center'>
              {item.carPolicyList.map(carPolicy => (
                <StyledCarPolicy key={carPolicy.uds_carpolicyid}>{carPolicy.uds_name}</StyledCarPolicy>
              ))}
            </Flex>
          )}
        </div>

        <div className={classes.new_uds_price_container}>
          <div>
            {(isEmployeeConfigurationsPage || isDriverConfigurationPage) &&
            !isShowInfoHint(item.uds_remove_request_date?.value) ? (
              <div className={'hidden-xs hidden-sm mb-1'}>
                <More>
                  <MoreMenuItem
                    label='Konfiguration archivieren'
                    minWidth={'240px'}
                    onClick={openDeactivateDialog}
                    img={<DeactivateIcon />}
                    isLeftPositionImg={true}
                  />
                </More>
              </div>
            ) : null}

            {([
              OFFER_STATUSES.requirementApproved,
              OFFER_STATUSES.vehicleRequested,
              OFFER_STATUSES.purchaseTriggered,
              OFFER_STATUSES.approvedByFleetManager,
              OFFER_STATUSES.orderApproved,
              OFFER_STATUSES.approvalRejected,
              OFFER_STATUSES.globalReferenceVehicleGeneratedViaAPI,
              OFFER_STATUSES.vehicleConfigurationBasedOnGRVCreated,
              OFFER_STATUSES.buildAbilityConfirmed,
              OFFER_STATUSES.orderCompleted,
              OFFER_STATUSES.dealershipSelected,
              OFFER_STATUSES.approvalFlowStarted
            ].includes(vehicleOfferStatus) &&
              priceWithoutFuelCost) ||
            (isEmployeeConfigurationsPage && priceWithoutFuelCost) ? (
              <div className={classes.new_uds_price_section}>
                <div className={classes.new_uds_netto_price}>
                  {(isNewDriverConfigurationPage ||
                    isDriverConfigurationPage ||
                    (isNewEmployeeConfigurationsPage && isGlobalReferenceVehicle) ||
                    (isEmployeeConfigurationsPage && isBasedOnGlobalReferenceVehicle)) &&
                  priceWithoutFuelCost &&
                  ![OFFER_STATUSES.orderApproved, OFFER_STATUSES.orderCompleted].includes(vehicleOfferStatus)
                    ? 'ab '
                    : ''}

                  <Price
                    // @ts-ignore
                    item={item}
                    type='/ Monat'
                    fuelCost={fuelCost}
                    priceWithoutFuelCost={priceWithoutFuelCost}
                  />
                </div>
                <div className={classes.new_uds_brutto_price}>
                  {(isNewDriverConfigurationPage ||
                    isDriverConfigurationPage ||
                    (isNewEmployeeConfigurationsPage && isGlobalReferenceVehicle) ||
                    (isEmployeeConfigurationsPage && isBasedOnGlobalReferenceVehicle)) &&
                  priceWithoutFuelCost &&
                  ![OFFER_STATUSES.orderApproved, OFFER_STATUSES.orderCompleted].includes(vehicleOfferStatus)
                    ? 'ab '
                    : ''}

                  <Price
                    // @ts-ignore
                    item={item}
                    type='(inkl. MwSt.)'
                    fuelCost={fuelCost}
                    priceWithoutFuelCost={priceWithoutFuelCost}
                  />
                </div>
              </div>
            ) : null}

            {fuelCost > 0 && (
              <>
                <Flex direction='column' top='25' bottom='10'>
                  <Flex align='center' justify='flex-end'>
                    <CarWithEuroIcon color={theme.colors.darkBlue} />
                    <Text bold color='darkBlue' size='18' left='10'>
                      {toMoney(priceWithoutFuelCost)}
                    </Text>
                  </Flex>

                  <Flex top='10' align='center' justify='flex-end'>
                    <GasStationIcon color={theme.colors.darkBlue} />
                    <Text bold color='darkBlue' size='18' left='10'>
                      {toMoney(fuelCost)}
                    </Text>
                  </Flex>
                </Flex>
              </>
            )}
          </div>

          {![OFFER_STATUSES.approvalRejected, OFFER_STATUSES.globalReferenceVehicleGeneratedViaAPI].includes(
            vehicleOfferStatus
          ) &&
            !isEmployeeConfigurationsPage &&
            !isBasedOnGlobalReferenceVehicle &&
            !isFahrzeugeDerCarPolicyPage && (
              <div className={classes.new_uds_info_section}>
                {!isNewEmployeeConfigurationsPage && (
                  <>
                    <InfoItem>{'Fahrzeug Anfordern'}</InfoItem>
                    <div style={{ marginBottom: '5px' }} />
                    <InfoItem>{'Freigabe bekommen'}</InfoItem>
                    <div style={{ marginBottom: '5px' }} />
                    <InfoItem>{'Neues Auto Fahren'}</InfoItem>
                  </>
                )}
              </div>
            )}

          <div className={classes.new_uds_buttons_wrapper}>
            {/*{!(*/}
            {/*  isNewEmployeeConfigurationsPage ||*/}
            {/*  isNewDriverConfigurationPage ||*/}
            {/*  isFahrzeugeDerCarPolicyPage ||*/}
            {/*  isBasedOnGlobalReferenceVehicle*/}
            {/*) && <OfferStatusSection status={vehicleOfferStatus} />}*/}

            {(isNewEmployeeConfigurationsPage || isFahrzeugeDerCarPolicyPage) &&
              !isBasedOnGlobalReferenceVehicle &&
              !isGlobalReferenceVehicle && (
                <div className='alles-inklusive'>
                  {isShowAllesInklusive && <AllInclusive />}
                  <Flex bottom='20' align='center' onMouseEnter={showAllesInklusive} onMouseLeave={hideAllesInklusive}>
                    <Text as='span' right='5' color='grey600' size='12'>
                      Alles inklusive - nur noch tanken!
                    </Text>
                    <CircleQuestionMarkIcon color={'#777777'} width='13' height='13' />
                  </Flex>
                </div>
              )}

            {!(
              isNewEmployeeConfigurationsPage ||
              isNewDriverConfigurationPage ||
              isFahrzeugeDerCarPolicyPage ||
              isBasedOnGlobalReferenceVehicle
            ) && (
              <div className={classes.new_uds_dates}>
                {isEmployeeConfigurationsPage && configurationCreatedEvent?.uds_erstelltfurid && (
                  <div style={{ marginBottom: '-2px' }}>
                    <DateInfo
                      icon={<CustomersIcon color={theme.colors.grey600} width='18' height='15' />}
                      title={isPoolcar ? '' : 'Fahrer:'}
                      value={isPoolcar ? 'Poolcar' : configurationCreatedEvent.uds_erstelltfurid.name || ''}
                    />
                  </div>
                )}
                {[
                  OFFER_STATUSES.offerRequested,
                  OFFER_STATUSES.priceRequested,
                  OFFER_STATUSES.requirementApproved,
                  OFFER_STATUSES.vehicleRequested,
                  OFFER_STATUSES.purchaseTriggered,
                  OFFER_STATUSES.approvedByFleetManager,
                  OFFER_STATUSES.orderApproved
                ].includes(vehicleOfferStatus) &&
                  item.uds_wunschlieferdatum && (
                    <DateInfo
                      icon={<CalendarIcon color={theme.colors.grey600} width='15' height='13' />}
                      title='Wunschlieferdatum:'
                      value={getDateString(item.uds_wunschlieferdatum.value)}
                    />
                  )}
              </div>
            )}

            {isBasedOnGlobalReferenceVehicle && (
              <div className={classes.new_uds_dates}>
                {isEmployeeConfigurationsPage && vehicleConfigurationBasedOnGRVCreatedEvent?.uds_erstelltfurid && (
                  <DateInfo
                    icon={<CustomersIcon color={theme.colors.grey600} width='18' height='15' />}
                    title='Fahrer:'
                    value={vehicleConfigurationBasedOnGRVCreatedEvent.uds_erstelltfurid.name || ''}
                  />
                )}
              </div>
            )}

            {isBasedOnBulkOrderVehicle &&
              isEmployeeConfigurationsPage &&
              vehicleBasedOnBulkOrderCreatedEvent?.uds_erstelltfurid && (
                <div className={classes.new_uds_dates}>
                  <DateInfo
                    icon={<CustomersIcon color={theme.colors.grey600} width='18' height='15' />}
                    title='Fahrer:'
                    value={vehicleBasedOnBulkOrderCreatedEvent.uds_erstelltfurid.name || ''}
                  />
                </div>
              )}
          </div>
        </div>
      </div>

      <div className={classes.new_uds_buttons_container}>
        {/*<Flex align='center'>*/}
        {/*  <ThreeStateCheckbox*/}
        {/*    checked={isCarCompared}*/}
        {/*    indeterminate={false}*/}
        {/*    onChange={isCarCompared ? deleteCarFromComparison : addCarToComparison}*/}
        {/*  />*/}
        {/*  <Text*/}
        {/*    wordBreak='break-word'*/}
        {/*    pointer*/}
        {/*    left='10'*/}
        {/*    onClick={isCarCompared ? deleteCarFromComparison : addCarToComparison}*/}
        {/*  >*/}
        {/*    Vergleichen*/}
        {/*  </Text>*/}
        {/*</Flex>*/}
        <div />

        <Flex align='center'>
          <Flex right='10'>
            <ButtonWithIcon
              tooltip='Frage stellen'
              icon={<AskQuestionIcon />}
              onClick={e => openCreateNewTaskModal(e)}
            />
          </Flex>

          <div className={`button-mobexo button-mobexo__main ${classes.new_uds_offer_offer}`}>
            {buttonText}
            {isShowIcon && <DownArrow className={classes.down_arrow} width={'10'} height={'14'} />}
          </div>
        </Flex>
      </div>

      <Snackbar
        open={!!snackbar.message}
        type={snackbar.type}
        time={6000}
        onClose={() => {
          setSnackbar({ ...snackbar, message: '' });
        }}
        message={snackbar.message}
      />
    </section>
  );
};

export default Product;
